import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepOneCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepOneCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.climbStepOneCollections.data.climbStepOneCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.climbStepOneCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
